import { Plugin } from 'ckeditor5';
import { Users } from 'ckeditor5-premium-features';

// UsersIntegration Plugin
export default class UsersIntegration extends Plugin {
    static get requires() {
        return ['Users'];
    }

    static get pluginName() {
        return 'UsersIntegration';
    }

    init() {
        const usersPlugin = this.editor.plugins.get('Users') as Users;
        console.log('users', usersPlugin)
        // These are sample users for demonstration purposes.
        // In your integration make sure to provide user data from your data source.
        const alluser = sessionStorage.getItem('commUser')
            ? JSON.parse(sessionStorage.getItem('commUser')!!)
            : {};
        let users = [];
        for (let uid of alluser) {
            let item = { id: uid, name: uid };
            users.push(item)
        }
        console.log(users)
        /* const users = [
             { id: 'user-1', name: 'Zee Croce' },
             { id: 'user-2', name: 'Mex Haddox' }
         ];*/
        const me = users[0];

        for (const user of users) {
            usersPlugin.addUser(user);
        }

        usersPlugin.defineMe(me.id);
    }
}